var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.521,
    height: 37.853,
    viewBox: "0 0 37.521 37.853",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.521,
    height: 37.853,
    fill: "#0087ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.225,19.878v15.2c0,2.259-.5,2.755-2.7,2.756-2.612,0-5.227-.049-7.837.021-1.372.037-1.919-.457-1.893-1.851.061-3.188.019-6.372.019-9.662H16.734v9.29c0,2.121-.085,2.2-2.221,2.205-2.565,0-5.129.007-7.692,0-1.918-.007-2.488-.57-2.494-2.526-.014-4.5,0-9,0-13.493V19.878A10.434,10.434,0,0,1,1.8,19.831,2.811,2.811,0,0,1,.051,18.645a2.151,2.151,0,0,1,.5-1.9C6.144,11.322,11.79,5.963,17.444.605A1.793,1.793,0,0,1,19.975.451a1.9,1.9,0,0,1,.186.19C25.771,5.971,31.39,11.293,36.942,16.682a2.311,2.311,0,0,1,.526,2.023c-.212.54-1.1.956-1.772,1.134a10.381,10.381,0,0,1-2.471.039M14.5,35.561c0-3.354.026-6.541-.013-9.723-.015-1.285.478-1.875,1.8-1.805,1.206.064,2.418.013,3.628.013,3.133,0,3.134,0,3.135,3.064v8.416H30.98V20.808c0-2.748.256-3.005,3.059-3.123a2.951,2.951,0,0,0,.606-.2L18.771,2.368l-16,15.25c.541.041.767.069.992.075,2.42.057,2.8.455,2.8,2.933V35.562Z",
    transform: "translate(0 0)",
    fill: "#0087ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.99e215c9d3fbfe1ef36a0f6cf84dfd95.svg";
export { ForwardRef as ReactComponent };